// дескриптор клиента
export const Client = {
    id: 'client',
    title: 'Клиент',
    EditFbsFbo:false,
    // в данном случае доступные вкладки
    items: [
        {id:'myProduct', title: 'Мой товар', icon: 'myProduct'},
        // {id:'myProductModern', title: 'Мой товар 2', icon: 'myProduct'},
        // {id:'myTechTasks', title: 'Тех. задания'},
        // {id:'createDealModern', title: 'Сделки 2'},
        {id:'createDelivery', title: 'Сделки', icon: 'createDelivery'}, 
        {id:'ClientProductStorage', title: 'Хранение товара', icon: 'storageProducts'}, 
        {id:'myConsumables', title: 'Расходники', icon: 'myProduct'}, 
        {id:'ClientsRSRDs', title: 'Возвраты', icon: 'myProduct'}, 
        // {id:'ClientWorkers', title: 'Сотрудники', icon: 'myProduct'}, 
      ],
        
  };

export const settingsClient = {
    id: 'clientSettings',
    title: 'Настройки',
    tabs: ['clientSettings'],
    defaultTab: 'clientSettings',
  };

  // Дескриптор для сделки
  export const DealClient = {
    id: 'dealClient',
    title: 'Сделка',
    // бридж
    api:'productsClientBridge',
    // свойство для report table показывать ли чекбоксы на каждую строку
    showCheckboxes: false,
    // свойство для report table для расширения строки доп данными
    expanded:false,  
    additionalOrientation: "column",
    items: [
      // id - путь в данных
      // title - наименование данных для отображения
      // formatter - какой форматтер применять к данным см formatters
            // {id: 'data.photo' , title: 'Фото', formatter: "imageFormatProduct"},
            // {id: 'data.title', title: 'Наименование товара', formatter: 'DefaultTypography', width: '180px'},
            { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo', width:'400px'},
            { id:'size.techTask', title: 'Техническое задание', formatter: 'UploadTechTaskButton', width:'400px'},
            // {id: 'size.title', title: 'Размер', formatter: 'DefaultTypography', sortable: true},
            // {id: 'data.color', title: 'Цвет', formatter: 'ColorsList', sortable: true},
            // {id:'size', title: 'Штрих код', formatter: "BarCode", width: '180px', sortable: true},
            { id:'qrcode', title: 'QR код', formatter: "UploadQrButton", width: '80px'},
            // {id:'size.countQr', title: 'Кол. QR', formatter: 'DefaultTypography', width: '100px'},
            { id: 'data.dimensions', title: 'Объем', formatter: 'ProductDim', width: '120px'},
            { id: 'countProduct', title: 'Кол.', formatter: 'ProductCountFK'},
            { id: 'totalStorage', title: 'На хранении фф', formatter: 'DefaultTypography', width:'80px' },
            // { id: 'size.inbox', title: 'Квант', formatter: 'DefaultTypography', width:'80px'},
    ]
  };

   export const DealClientConsum = {
    id: 'dealClientConsum',
    title: 'Сделка',
    // бридж
    api:'productsClientBridge',
    // свойство для report table показывать ли чекбоксы на каждую строку
    showCheckboxes: false,
    // свойство для report table для расширения строки доп данными
    expanded:true,  
    items: [
      // id - путь в данных
      // title - наименование данных для отображения
      // formatter - какой форматтер применять к данным см formatters
      { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo', width:'400px'},
      // {id: 'size.title', title: 'Размер', formatter: 'DefaultTypography', sortable: true},
      // {id: 'data.color', title: 'Цвет', formatter: 'ColorsList', sortable: true},
      // {id:'size', title: 'Штрих код', formatter: "BarCode", width: '180px', sortable: true},
      { id:'qrcode', title: 'QR код', formatter: "UploadQrButtonConsum", width: '80px'},
      // {id:'size.countQr', title: 'Кол. QR', formatter: 'DefaultTypography', width: '100px'},
      { id: 'data.dimensions', title: 'Объем', formatter: 'ProductDim', width: '120px'},
      { id:'countProduct', title: 'Кол.', formatter: 'DefaultTypography'},
      { id: 'totalStorage', title: 'На хранении фф', formatter: 'DefaultTypography', width:'80px' },
      // { id: 'size.inbox', title: 'Квант', formatter: 'DefaultTypography', width:'80px'},
    ]
  };

  export const AddClientWorker = {
    id: 'addClientWorker',
    api: 'defBridge',
    title: 'Добавление',
    tabs: ['clientWorker'],
    defaultTab: 'clientWorker',
    
  };

  export const EditClientWorker = {
    id: 'editClientWorker',
    api: 'defBridge',
    title: 'Редактирование',
    tabs: ['clientWorker'],
    defaultTab: "clientWorker",
  };

  export const ClientsRoles = {
    id: 'ClientsRoles',
    api: 'defBridge',
    title: 'Роли',
    rules: [
      {id: "client.main.my_products", title: "Основное - Мой товар"},
      {id: "client.main.delivery", title: "Основное - Поставки"},
      {id: "client.main.storage", title: "Основное - Хранение товара"},
      {id: "client.main.consumabels", title: "Основное - Расходники"},
    ]
  };


  export const cliWorkerList = {
    id: 'cliWorkerList',
    title: 'Список сотрудников',
    // бридж
    api:'default',
    showCheckboxes: false,
    expanded:false,  
    items: [
      {id: 'fio' , title: 'ФИО', formatter: "DefaultTypography"},
      {id: 'mobile_number', title: 'Телефон', formatter: 'DefaultTypography'},
      {id: 'email', title: 'Почта', formatter: 'DefaultTypography'},
      {id: 'roles', title: 'Роли', formatter: 'ShowList'},
    ]
  };
